$(document).on('click', '.modal-open', function (e) {
    e.preventDefault();
    $('.mobile-menu-icon .icon').removeClass('close')
    $('.mobile-menu').hide()

    let product = $(this).data('product');

    $.when($(this).data('modal')).then(function (name) {
        $('#modal_box').load('/popup/' + name, {product: product}, function (response, status, xhr) {
            $('html').css('overflow', 'hidden');
            $(this).show();
        });
    });
});

$(document).on('click', '.modal', function (e) {
    if (e.target === this || $(e.target).hasClass('modal__close')) {
        // Clear error inputs
        $(this).find('.form__input.error').removeClass('error');
        $(this).find('.input__error').remove();

        // Toggle success element
        $(this).find('.modal__error').hide();
        $(this).find('.modal__success').hide();
        $(this).find('.modal__content').show();

        // Hide form
        $(this).hide();

        // Clear overflow
        $('html').css('overflow', '')
    }
});
